import React from 'react'

export const SessionContext = React.createContext<any>({})
export const SessionContextProvider = SessionContext.Provider
export const SessionContextConsumer = SessionContext.Consumer
